import React, { FC } from 'react';
import { Grid } from '@mui/material';
import {
    SCUIRefundDetailCustomerInfo,
    SCUIRefundDetailPaymentInfo,
    SCUIRefundHistory,
    RefundPrepareSellerReturnShipment,
    RefundWaitingPayment,
} from '../index';
import { CloseRefundRecordButton } from '../CloseRefundRecordButton/CloseRefundRecordButton';
import { PaymentConversionCard } from '../PaymentConversionCard/PaymentConversionCard';

type RefundV2TabContentProps = {
    tabIndex: any;
    paymentListInfo: any;
    payBackListInfo: any;
    currencySymbol: any;
    refundId: any;
    orderDate: any;
    shippingListId: any;
    customerId: any;
    irsaliyeFaturaSeriNo: any;
    returnId: any;
    waitingRefundVisible: boolean;
    getRefundDetails: any;
    returnDatas: any;
    orderId: any;
    customerChoiceBankAccountId: any;
    hasPaymentConversionCloseRefundRole: boolean;
};

const fullWidthGridSize = {
    xs: 12,
    md: 12,
    lg: 12,
    xl: 12,
};

export const RefundV2TabContent: FC<RefundV2TabContentProps> = ({
    tabIndex,
    paymentListInfo,
    payBackListInfo,
    currencySymbol,
    refundId,
    orderDate,
    shippingListId,
    customerId,
    irsaliyeFaturaSeriNo,
    returnId,
    waitingRefundVisible,
    getRefundDetails,
    returnDatas,
    orderId,
    customerChoiceBankAccountId,
    hasPaymentConversionCloseRefundRole,
}) => {
    if (tabIndex === 1 && paymentListInfo) {
        return (
            <Grid size={fullWidthGridSize}>
                <SCUIRefundDetailCustomerInfo paymentResult={paymentListInfo} />
            </Grid>
        );
    }

    if (tabIndex === 2 && payBackListInfo) {
        return (
            <Grid size={fullWidthGridSize}>
                <SCUIRefundDetailPaymentInfo
                    payBackListInfo={payBackListInfo}
                    currencySymbol={currencySymbol}
                    refundId={refundId}
                    customerId={customerId}
                />
            </Grid>
        );
    }

    if (tabIndex === 3) {
        return (
            <Grid size={fullWidthGridSize}>
                <SCUIRefundHistory refundId={refundId} orderDate={orderDate} />
            </Grid>
        );
    }

    if (tabIndex === 4) {
        return (
            <Grid size={fullWidthGridSize}>
                <RefundPrepareSellerReturnShipment
                    shippingListId={shippingListId}
                    customerId={customerId}
                    irsaliyeFaturaSeriNo={irsaliyeFaturaSeriNo}
                    returnId={returnId}
                />
            </Grid>
        );
    }

    if (tabIndex === 5 && waitingRefundVisible && getRefundDetails) {
        return (
            <Grid size={fullWidthGridSize}>
                <RefundWaitingPayment
                    currencySymbol={currencySymbol}
                    orderId={orderId}
                    returnDatas={returnDatas}
                    customerId={customerId}
                    refundId={refundId}
                    refundDetails={getRefundDetails}
                    orderDate={orderDate}
                    returnId={returnId}
                    refundDetailId={getRefundDetails?.entity?.refundDetails[0]?.refundDetailId}
                    customerChoiceBankAccountId={customerChoiceBankAccountId}
                    getRefundDetails={getRefundDetails}
                />
            </Grid>
        );
    }

    if (tabIndex === 6 && getRefundDetails) {
        return (
            <Grid size={fullWidthGridSize}>
                <Grid container spacing={2}>
                    <Grid
                        size={{
                            xs: 12,
                            sm: 6,
                            md: 4,
                            lg: 3,
                        }}
                    >
                        {hasPaymentConversionCloseRefundRole && (
                            <CloseRefundRecordButton
                                refundId={refundId}
                                orderId={orderId}
                                returnId={returnId}
                                customerId={customerId}
                                refundDetails={getRefundDetails}
                                orderDate={orderDate}
                                returnDatas={returnDatas}
                                fullwidth
                            />
                        )}
                        <PaymentConversionCard
                            refundId={refundId}
                            refundAmount={getRefundDetails?.entity?.refundAmount}
                            currencySymbol={paymentListInfo?.items?.[0]?.currencySymbol}
                        />
                    </Grid>
                </Grid>
            </Grid>
        );
    }

    return null;
};
